import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
import { palette } from '@material-ui/system';

import Text from 'components/Text';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'inline-flex',
    padding: theme.spacing((1 / 8) * 2, (1 / 8) * 4),
    borderRadius: 4,
    alignItems: 'center',
    backgroundColor: ({ backgroundColor }) => {
      return palette({ theme, color: backgroundColor }).color;
    },
  },
}));

const TextLabel = (props) => {
  const {
    children,
    className,
    component = 'span',
    variant = 'caption3',
    color = 'colors.grey700',
    backgroundColor = 'colors.grey200',
    view = 'mobile',
    ...rest
  } = props;

  const classes = useStyles({ backgroundColor });

  return (
    <Text
      {...rest}
      view={view}
      color={color}
      variant={variant}
      component={component}
      className={cx(classes.root, className)}
    >
      {children}
    </Text>
  );
};

export default TextLabel;
